import React, { useState,useRef  } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Button2 from "../Buttons/Button2";
import "./PopularLocations.css";
import { useNavigate } from "react-router-dom";

const Card = ({data}) => {
  //console.log(data,"zxcvbnm")




const slidesdummy = [
  {
    source:
      "https://images.unsplash.com/photo-1610513320995-1ad4bbf25e55?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
  },
];

const [slides, setSlide] = useState(slidesdummy);
const navigate = useNavigate();

const handleCardClick = (villaId, villaName) => {
  
  const hyphenatedVillaName = data.property_name.replace(/\s+/g, '-');
  navigate(`/villa/${data.id}/${hyphenatedVillaName}`)
  window.location.reload();
};



const handleimages = () => {
  if (data.media_order.length > 0) {
    data.media?.sort((a, b) => {
      const indexA = data.media_order.indexOf(a.id);
      const indexB = data.media_order.indexOf(b.id);
      return indexA - indexB;
    });
  }

  if (data.media.length > 0) {
    const newArray = data.media.map((item) => {
      return {
        source: item.file,
      };
    });

    setSlide(newArray);
  }
  else{
    setSlide(slidesdummy)
  }
};
const linkRef = useRef(null)
useEffect(() => {
  handleimages();
}, [data]);








  return (
    <div className="">
      <a href className="card">
        <img src={data.media[0]?.file ? data.media[0]?.file:"https://img.freepik.com/free-vector/glitch-error-404-page_23-2148105404.jpg"} className="card__image" alt="" />
        <div className="card__overlay">
          <div className="card__header">
            <svg className="card__arc" xmlns="http://www.w3.org/2000/svg">
              <path />
            </svg>
            <div className="rounded-full w-12 h-12 text-center pt-[9.5px] bg-[#129531] text-white font-semibold text-lg">
              {data.a2z_score? data.a2z_score :0}
            </div>
            {/* <img
              className="card__thumb"
              src="https://cdn-icons-png.flaticon.com/512/8068/8068401.png"
              alt=""
            /> */}
            <div className="card__header-text">
              <h3 className="card__title">{data.property_name}</h3>
              <span className="card__status">{data.address.city.name}</span>
            </div>
          </div>
          <div className="ml-[87px] mb-5">
          <button 
            onClick={handleCardClick}
          className="font-hk text-center bg-opacity-90 py-3 transition-all hover:scale-[1.05] shadow-black hover:shadow-lg text-[12px] md:text-[13px] xl:text-sm font-medium text-white bg-black border-[1px] rounded-2xl lg:rounded-full h-[45px] w-[90px] md:w-[105px] xl:w-[130px]">
      Take Me There
    </button>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Card;
